export function DashboardIcon() {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1139_4728)">
        <path
          d="M7.96875 5.75C7.96875 5.62568 7.91936 5.50645 7.83146 5.41854C7.74355 5.33064 7.62432 5.28125 7.5 5.28125C7.37568 5.28125 7.25645 5.33064 7.16854 5.41854C7.08064 5.50645 7.03125 5.62568 7.03125 5.75V8.46875H4.21875C4.09443 8.46875 3.9752 8.51814 3.88729 8.60604C3.79939 8.69395 3.75 8.81318 3.75 8.9375C3.75 9.06182 3.79939 9.18105 3.88729 9.26896C3.9752 9.35686 4.09443 9.40625 4.21875 9.40625H7.5C7.62432 9.40625 7.74355 9.35686 7.83146 9.26896C7.91936 9.18105 7.96875 9.06182 7.96875 8.9375V5.75Z"
          fill="currentColor"
        />
        <path
          d="M6.09358 1.4375C6.09358 1.31318 6.14297 1.19395 6.23088 1.10604C6.31878 1.01814 6.43801 0.96875 6.56233 0.96875H8.43733C8.56165 0.96875 8.68088 1.01814 8.76879 1.10604C8.8567 1.19395 8.90608 1.31318 8.90608 1.4375C8.90608 1.56182 8.8567 1.68105 8.76879 1.76896C8.68088 1.85686 8.56165 1.90625 8.43733 1.90625V2.44062C9.71233 2.62437 10.8692 3.17188 11.7973 3.97812C11.801 3.97402 11.8048 3.96995 11.8086 3.96594L12.1405 3.63406L11.8086 3.30312C11.7206 3.21523 11.6711 3.09597 11.671 2.97158C11.6709 2.84719 11.7202 2.72786 11.8081 2.63984C11.896 2.55182 12.0153 2.50233 12.1397 2.50224C12.264 2.50215 12.3834 2.55148 12.4714 2.63937L13.797 3.96594C13.8418 4.00918 13.8775 4.0609 13.9021 4.11809C13.9266 4.17528 13.9396 4.23679 13.9401 4.29903C13.9406 4.36127 13.9288 4.423 13.9052 4.4806C13.8816 4.53821 13.8468 4.59055 13.8028 4.63456C13.7588 4.67857 13.7065 4.71338 13.6489 4.73695C13.5913 4.76052 13.5295 4.77238 13.4673 4.77184C13.4051 4.7713 13.3435 4.75836 13.2864 4.7338C13.2292 4.70923 13.1774 4.67352 13.1342 4.62875L12.8033 4.29688L12.4714 4.62875C12.4674 4.63257 12.4633 4.63632 12.4592 4.64C13.4137 5.74189 13.9742 7.13026 14.0521 8.58602C14.1301 10.0418 13.7211 11.4821 12.8896 12.6796C12.0582 13.8771 10.8517 14.7637 9.46048 15.1994C8.06927 15.6351 6.57258 15.5952 5.20657 15.0859C3.84057 14.5767 2.68303 13.6271 1.9166 12.3869C1.15018 11.1468 0.818511 9.68677 0.973933 8.23723C1.12936 6.78769 1.76302 5.43117 2.77494 4.38172C3.78686 3.33227 5.11941 2.64965 6.56233 2.44156V1.90625C6.43801 1.90625 6.31878 1.85686 6.23088 1.76896C6.14297 1.68105 6.09358 1.56182 6.09358 1.4375ZM7.49983 3.3125C6.76115 3.31256 6.02971 3.45812 5.34727 3.74086C4.66484 4.0236 4.04478 4.43798 3.52249 4.96036C2.46769 6.01534 1.87518 7.44613 1.8753 8.93797C1.87542 10.4298 2.46818 11.8605 3.52316 12.9153C4.57814 13.9701 6.00893 14.5626 7.50077 14.5625C8.99261 14.5624 10.4233 13.9696 11.4781 12.9146C12.5329 11.8597 13.1254 10.4289 13.1253 8.93703C13.1252 7.44519 12.5324 6.0145 11.4774 4.95969C10.4225 3.90489 8.99167 3.31238 7.49983 3.3125Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1139_4728">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function MatchingIcon() {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1139_4731)">
        <path
          d="M13.125 1.4375C13.3736 1.4375 13.6121 1.53627 13.7879 1.71209C13.9637 1.8879 14.0625 2.12636 14.0625 2.375V13.625C14.0625 13.8736 13.9637 14.1121 13.7879 14.2879C13.6121 14.4637 13.3736 14.5625 13.125 14.5625H1.875C1.62636 14.5625 1.3879 14.4637 1.21209 14.2879C1.03627 14.1121 0.9375 13.8736 0.9375 13.625V2.375C0.9375 2.12636 1.03627 1.8879 1.21209 1.71209C1.3879 1.53627 1.62636 1.4375 1.875 1.4375H13.125ZM1.875 0.5C1.37772 0.5 0.900805 0.697544 0.549175 1.04917C0.197544 1.40081 0 1.87772 0 2.375L0 13.625C0 14.1223 0.197544 14.5992 0.549175 14.9508C0.900805 15.3025 1.37772 15.5 1.875 15.5H13.125C13.6223 15.5 14.0992 15.3025 14.4508 14.9508C14.8025 14.5992 15 14.1223 15 13.625V2.375C15 1.87772 14.8025 1.40081 14.4508 1.04917C14.0992 0.697544 13.6223 0.5 13.125 0.5H1.875Z"
          fill="currentColor"
        />
        <path
          d="M5.625 11.2812C5.625 11.1569 5.67439 11.0377 5.76229 10.9498C5.8502 10.8619 5.96943 10.8125 6.09375 10.8125H8.90625C9.03057 10.8125 9.1498 10.8619 9.23771 10.9498C9.32561 11.0377 9.375 11.1569 9.375 11.2812C9.375 11.4056 9.32561 11.5248 9.23771 11.6127C9.1498 11.7006 9.03057 11.75 8.90625 11.75H6.09375C5.96943 11.75 5.8502 11.7006 5.76229 11.6127C5.67439 11.5248 5.625 11.4056 5.625 11.2812ZM3.75 8.46875C3.75 8.34443 3.79939 8.2252 3.88729 8.13729C3.9752 8.04939 4.09443 8 4.21875 8H10.7812C10.9056 8 11.0248 8.04939 11.1127 8.13729C11.2006 8.2252 11.25 8.34443 11.25 8.46875C11.25 8.59307 11.2006 8.7123 11.1127 8.80021C11.0248 8.88811 10.9056 8.9375 10.7812 8.9375H4.21875C4.09443 8.9375 3.9752 8.88811 3.88729 8.80021C3.79939 8.7123 3.75 8.59307 3.75 8.46875ZM1.875 5.65625C1.875 5.53193 1.92439 5.4127 2.01229 5.32479C2.1002 5.23689 2.21943 5.1875 2.34375 5.1875H12.6562C12.7806 5.1875 12.8998 5.23689 12.9877 5.32479C13.0756 5.4127 13.125 5.53193 13.125 5.65625C13.125 5.78057 13.0756 5.8998 12.9877 5.98771C12.8998 6.07561 12.7806 6.125 12.6562 6.125H2.34375C2.21943 6.125 2.1002 6.07561 2.01229 5.98771C1.92439 5.8998 1.875 5.78057 1.875 5.65625Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1139_4731">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function StatisicsIcon() {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 2.375C0 2.12636 0.0987721 1.8879 0.274587 1.71209C0.450403 1.53627 0.68886 1.4375 0.9375 1.4375H14.0625C14.3111 1.4375 14.5496 1.53627 14.7254 1.71209C14.9012 1.8879 15 2.12636 15 2.375V13.625C15 13.8736 14.9012 14.1121 14.7254 14.2879C14.5496 14.4637 14.3111 14.5625 14.0625 14.5625H0.9375C0.68886 14.5625 0.450403 14.4637 0.274587 14.2879C0.0987721 14.1121 0 13.8736 0 13.625V2.375ZM7.96875 2.375V9.875H14.0625V2.375H7.96875ZM7.96875 10.8125V13.625H14.0625V10.8125H7.96875ZM7.03125 2.375H0.9375V5.1875H7.03125V2.375ZM0.9375 13.625H7.03125V6.125H0.9375V13.625Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function NoticeIcon() {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1875 2.84375C12.1875 2.47079 12.3357 2.1131 12.5994 1.84938C12.8631 1.58566 13.2208 1.4375 13.5938 1.4375C13.9667 1.4375 14.3244 1.58566 14.5881 1.84938C14.8518 2.1131 15 2.47079 15 2.84375V13.1563C15 13.5292 14.8518 13.8869 14.5881 14.1506C14.3244 14.4143 13.9667 14.5625 13.5938 14.5625C13.2208 14.5625 12.8631 14.4143 12.5994 14.1506C12.3357 13.8869 12.1875 13.5292 12.1875 13.1563V12.9556C10.1606 11.7922 7.97812 11.2278 5.7075 11.0028L6.08719 13.5453C6.11269 13.6808 6.108 13.8202 6.07348 13.9536C6.03895 14.087 5.97542 14.2112 5.88742 14.3173C5.79942 14.4234 5.68912 14.5088 5.56436 14.5673C5.4396 14.6259 5.30346 14.6563 5.16563 14.6563H4.65188C4.46965 14.6562 4.29137 14.6031 4.13886 14.5034C3.98634 14.4036 3.8662 14.2616 3.79312 14.0947L2.05875 10.8228C1.99563 10.8218 1.9325 10.8208 1.86937 10.82C1.37284 10.8151 0.898237 10.6147 0.548349 10.2624C0.19846 9.91005 0.00145485 9.43406 0 8.9375L0 7.0625C0.00167323 6.5659 0.198347 6.08983 0.547653 5.73684C0.896959 5.38385 1.37094 5.18219 1.8675 5.17531C2.64377 5.16479 3.41982 5.14135 4.19531 5.105C7.04812 4.96063 9.95906 4.30906 12.1875 3.04344V2.84375ZM13.125 2.84375V13.1563C13.125 13.2806 13.1744 13.3998 13.2623 13.4877C13.3502 13.5756 13.4694 13.625 13.5938 13.625C13.7181 13.625 13.8373 13.5756 13.9252 13.4877C14.0131 13.3998 14.0625 13.2806 14.0625 13.1563V2.84375C14.0625 2.71943 14.0131 2.6002 13.9252 2.51229C13.8373 2.42439 13.7181 2.375 13.5938 2.375C13.4694 2.375 13.3502 2.42439 13.2623 2.51229C13.1744 2.6002 13.125 2.71943 13.125 2.84375ZM12.1875 4.10938C9.99 5.23906 7.30406 5.83625 4.6875 6.01531V9.98375C4.85625 9.99313 5.02406 10.0044 5.19094 10.0175C7.59844 10.1947 9.96562 10.715 12.1875 11.8859V4.10938ZM3.75 9.93594V6.06406C3.12769 6.08684 2.50515 6.10309 1.8825 6.11281C1.63197 6.11576 1.39261 6.2169 1.21589 6.3945C1.03916 6.5721 0.939202 6.81196 0.9375 7.0625V8.9375C0.9375 9.45313 1.3575 9.87688 1.88063 9.88344C2.504 9.89066 3.12721 9.90816 3.75 9.93594ZM3.13406 10.85L4.6425 13.6972L4.65188 13.7197H5.16563L5.16375 13.7066L4.74844 10.9259C4.21066 10.8935 3.67249 10.8679 3.13406 10.8491V10.85Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function TuneIcon() {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.47223 4.25713C7.30573 4.25713 7.14605 4.32327 7.02831 4.44101C6.91058 4.55874 6.84444 4.71843 6.84444 4.88493C6.84444 5.05143 6.91058 5.21111 7.02831 5.32885C7.14605 5.44658 7.30573 5.51272 7.47223 5.51272C7.63873 5.51272 7.79842 5.44658 7.91615 5.32885C8.03389 5.21111 8.10003 5.05143 8.10003 4.88493C8.10003 4.71843 8.03389 4.55874 7.91615 4.44101C7.79842 4.32327 7.63873 4.25713 7.47223 4.25713ZM5.69557 4.25713C5.82527 3.88954 6.06581 3.57122 6.38401 3.34607C6.70222 3.12091 7.08243 3 7.47223 3C7.86204 3 8.24225 3.12091 8.56045 3.34607C8.87866 3.57122 9.11919 3.88954 9.2489 4.25713H13.7502C13.9167 4.25713 14.0764 4.32327 14.1941 4.44101C14.3118 4.55874 14.378 4.71843 14.378 4.88493C14.378 5.05143 14.3118 5.21111 14.1941 5.32885C14.0764 5.44658 13.9167 5.51272 13.7502 5.51272H9.2489C9.11919 5.88032 8.87866 6.19863 8.56045 6.42379C8.24225 6.64894 7.86204 6.76985 7.47223 6.76985C7.08243 6.76985 6.70222 6.64894 6.38401 6.42379C6.06581 6.19863 5.82527 5.88032 5.69557 5.51272H4.96105C4.79455 5.51272 4.63486 5.44658 4.51713 5.32885C4.39939 5.21111 4.33325 5.05143 4.33325 4.88493C4.33325 4.71843 4.39939 4.55874 4.51713 4.44101C4.63486 4.32327 4.79455 4.25713 4.96105 4.25713H5.69557ZM11.239 8.02391C11.0725 8.02391 10.9128 8.09005 10.7951 8.20779C10.6774 8.32552 10.6112 8.4852 10.6112 8.6517C10.6112 8.81821 10.6774 8.97789 10.7951 9.09562C10.9128 9.21336 11.0725 9.2795 11.239 9.2795C11.4055 9.2795 11.5652 9.21336 11.6829 9.09562C11.8007 8.97789 11.8668 8.81821 11.8668 8.6517C11.8668 8.4852 11.8007 8.32552 11.6829 8.20779C11.5652 8.09005 11.4055 8.02391 11.239 8.02391ZM9.46235 8.02391C9.59205 7.65631 9.83258 7.338 10.1508 7.11284C10.469 6.88769 10.8492 6.76678 11.239 6.76678C11.6288 6.76678 12.009 6.88769 12.3272 7.11284C12.6454 7.338 12.886 7.65631 13.0157 8.02391H13.7502C13.9167 8.02391 14.0764 8.09005 14.1941 8.20779C14.3118 8.32552 14.378 8.4852 14.378 8.6517C14.378 8.81821 14.3118 8.97789 14.1941 9.09562C14.0764 9.21336 13.9167 9.2795 13.7502 9.2795H13.0157C12.886 9.6471 12.6454 9.96541 12.3272 10.1906C12.009 10.4157 11.6288 10.5366 11.239 10.5366C10.8492 10.5366 10.469 10.4157 10.1508 10.1906C9.83258 9.96541 9.59205 9.6471 9.46235 9.2795H4.96105C4.79455 9.2795 4.63486 9.21336 4.51713 9.09562C4.39939 8.97789 4.33325 8.81821 4.33325 8.6517C4.33325 8.4852 4.39939 8.32552 4.51713 8.20779C4.63486 8.09005 4.79455 8.02391 4.96105 8.02391H9.46235ZM7.47223 11.7907C7.30573 11.7907 7.14605 11.8568 7.02831 11.9746C6.91058 12.0923 6.84444 12.252 6.84444 12.4185C6.84444 12.585 6.91058 12.7447 7.02831 12.8624C7.14605 12.9801 7.30573 13.0463 7.47223 13.0463C7.63873 13.0463 7.79842 12.9801 7.91615 12.8624C8.03389 12.7447 8.10003 12.585 8.10003 12.4185C8.10003 12.252 8.03389 12.0923 7.91615 11.9746C7.79842 11.8568 7.63873 11.7907 7.47223 11.7907ZM5.69557 11.7907C5.82527 11.4231 6.06581 11.1048 6.38401 10.8796C6.70222 10.6545 7.08243 10.5336 7.47223 10.5336C7.86204 10.5336 8.24225 10.6545 8.56045 10.8796C8.87866 11.1048 9.11919 11.4231 9.2489 11.7907H13.7502C13.9167 11.7907 14.0764 11.8568 14.1941 11.9746C14.3118 12.0923 14.378 12.252 14.378 12.4185C14.378 12.585 14.3118 12.7447 14.1941 12.8624C14.0764 12.9801 13.9167 13.0463 13.7502 13.0463H9.2489C9.11919 13.4139 8.87866 13.7322 8.56045 13.9573C8.24225 14.1825 7.86204 14.3034 7.47223 14.3034C7.08243 14.3034 6.70222 14.1825 6.38401 13.9573C6.06581 13.7322 5.82527 13.4139 5.69557 13.0463H4.96105C4.79455 13.0463 4.63486 12.9801 4.51713 12.8624C4.39939 12.7447 4.33325 12.585 4.33325 12.4185C4.33325 12.252 4.39939 12.0923 4.51713 11.9746C4.63486 11.8568 4.79455 11.7907 4.96105 11.7907H5.69557Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PlusIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9992 0.579102C11.3447 0.579102 11.676 0.716343 11.9203 0.960634C12.1646 1.20492 12.3018 1.53625 12.3018 1.88173V9.69752H20.1176C20.4631 9.69752 20.7944 9.83476 21.0387 10.0791C21.283 10.3233 21.4202 10.6547 21.4202 11.0002C21.4202 11.3456 21.283 11.677 21.0387 11.9213C20.7944 12.1655 20.4631 12.3028 20.1176 12.3028H12.3018V20.1186C12.3018 20.4641 12.1646 20.7954 11.9203 21.0397C11.676 21.284 11.3447 21.4212 10.9992 21.4212C10.6537 21.4212 10.3224 21.284 10.0781 21.0397C9.83379 20.7954 9.69655 20.4641 9.69655 20.1186V12.3028H1.88076C1.53528 12.3028 1.20395 12.1655 0.959657 11.9213C0.715366 11.677 0.578125 11.3456 0.578125 11.0002C0.578125 10.6547 0.715366 10.3233 0.959657 10.0791C1.20395 9.83476 1.53528 9.69752 1.88076 9.69752H9.69655V1.88173C9.69655 1.53625 9.83379 1.20492 10.0781 0.960634C10.3224 0.716343 10.6537 0.579102 10.9992 0.579102Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ZoomInIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.45508 11H20.546"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M11 1.45447L11 20.5454"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function ZoomOutIcon() {
  return (
    <svg
      width="16"
      height="4"
      viewBox="0 0 22 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.45483 2H20.5457"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function MyLocationIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5748 6.23193C15.3013 6.23193 12.1618 7.53234 9.84708 9.84708C7.53234 12.1618 6.23193 15.3013 6.23193 18.5748C6.23193 21.8484 7.53234 24.9879 9.84708 27.3026C12.1618 29.6173 15.3013 30.9178 18.5748 30.9178C21.8484 30.9178 24.9879 29.6173 27.3026 27.3026C29.6173 24.9879 30.9178 21.8484 30.9178 18.5748C30.9178 15.3013 29.6173 12.1618 27.3026 9.84708C24.9879 7.53234 21.8484 6.23193 18.5748 6.23193ZM8.04134 8.04134C10.835 5.24768 14.624 3.67822 18.5748 3.67822C22.5257 3.67822 26.3147 5.24768 29.1083 8.04134C31.902 10.835 33.4715 14.624 33.4715 18.5748C33.4715 22.5257 31.902 26.3147 29.1083 29.1083C26.3147 31.902 22.5257 33.4715 18.5748 33.4715C14.624 33.4715 10.835 31.902 8.04134 29.1083C5.24768 26.3147 3.67822 22.5257 3.67822 18.5748C3.67822 14.624 5.24768 10.835 8.04134 8.04134Z"
        fill="#5546A9"
        stroke="#5546A9"
        strokeWidth="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5746 14.7441C17.5586 14.7441 16.5843 15.1477 15.866 15.8661C15.1476 16.5844 14.744 17.5588 14.744 18.5747C14.744 19.5906 15.1476 20.5649 15.866 21.2833C16.5843 22.0017 17.5586 22.4053 18.5746 22.4053C19.5905 22.4053 20.5648 22.0017 21.2832 21.2833C22.0016 20.5649 22.4051 19.5906 22.4051 18.5747C22.4051 17.5588 22.0016 16.5844 21.2832 15.8661C20.5648 15.1477 19.5905 14.7441 18.5746 14.7441ZM14.0602 14.0603C15.2575 12.8631 16.8814 12.1904 18.5746 12.1904C20.2678 12.1904 21.8916 12.8631 23.0889 14.0603C24.2862 15.2576 24.9588 16.8815 24.9588 18.5747C24.9588 20.2679 24.2862 21.8918 23.0889 23.0891C21.8916 24.2863 20.2678 24.959 18.5746 24.959C16.8814 24.959 15.2575 24.2863 14.0602 23.0891C12.8629 21.8918 12.1903 20.2679 12.1903 18.5747C12.1903 16.8815 12.8629 15.2576 14.0602 14.0603Z"
        fill="#5546A9"
        stroke="#5546A9"
        strokeWidth="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5744 0.272949C19.2796 0.272949 19.8512 0.844616 19.8512 1.5498V4.95474C19.8512 5.65993 19.2796 6.2316 18.5744 6.2316C17.8692 6.2316 17.2975 5.65993 17.2975 4.95474V1.5498C17.2975 0.844616 17.8692 0.272949 18.5744 0.272949ZM0.272827 18.5745C0.272827 17.8693 0.844494 17.2977 1.54968 17.2977H4.95462C5.65981 17.2977 6.23147 17.8693 6.23147 18.5745C6.23147 19.2797 5.65981 19.8514 4.95462 19.8514H1.54968C0.844494 19.8514 0.272827 19.2797 0.272827 18.5745ZM30.9173 18.5745C30.9173 17.8693 31.489 17.2977 32.1941 17.2977H35.5991C36.3043 17.2977 36.8759 17.8693 36.8759 18.5745C36.8759 19.2797 36.3043 19.8514 35.5991 19.8514H32.1941C31.489 19.8514 30.9173 19.2797 30.9173 18.5745ZM18.5744 30.9174C19.2796 30.9174 19.8512 31.4891 19.8512 32.1943V35.5992C19.8512 36.3044 19.2796 36.8761 18.5744 36.8761C17.8692 36.8761 17.2975 36.3044 17.2975 35.5992V32.1943C17.2975 31.4891 17.8692 30.9174 18.5744 30.9174Z"
        fill="#5546A9"
        stroke="#5546A9"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function AddressIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.22105 0C4.34947 0 2 2.5061 2 5.56912C2 9.32828 6.56842 13.5747 6.76421 13.7836C6.89474 13.8532 7.09053 13.9228 7.22105 13.9228C7.35158 13.9228 7.54737 13.8532 7.67789 13.7836C7.87368 13.5747 12.4421 9.32828 12.4421 5.56912C12.4421 2.5061 10.0926 0 7.22105 0Z"
        fill="#5546A9"
      />
      <circle cx="7.19995" cy="5.66699" r="2" fill="white" />
    </svg>
  );
}

export function FolderIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 3.2461C1 2.91561 1.13128 2.59866 1.36497 2.36497C1.59866 2.13128 1.91561 2 2.2461 2H5.36134C5.52657 2.00004 5.68502 2.0657 5.80184 2.18255L6.86538 3.2461H12.2149C12.5454 3.2461 12.8623 3.37738 13.096 3.61107C13.3297 3.84476 13.461 4.16171 13.461 4.4922V10.7227C13.461 11.0532 13.3297 11.3701 13.096 11.6038C12.8623 11.8375 12.5454 11.9688 12.2149 11.9688H2.2461C1.91561 11.9688 1.59866 11.8375 1.36497 11.6038C1.13128 11.3701 1 11.0532 1 10.7227V3.2461Z"
        fill="#5546A9"
      />
    </svg>
  );
}

export function MapIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.81218 1.9651C4.93831 1.92309 5.07466 1.92309 5.20079 1.9651L8.69582 3.13031L11.381 2.23504C11.5659 2.17336 11.7628 2.15649 11.9554 2.18584C12.1481 2.21518 12.331 2.28989 12.4891 2.40381C12.6473 2.51773 12.776 2.6676 12.8649 2.84105C12.9537 3.01451 13 3.2066 13 3.40148V10.7143C13.0001 10.9725 12.919 11.2241 12.7682 11.4336C12.6173 11.643 12.4043 11.7997 12.1595 11.8814L8.89012 12.971C8.76399 13.013 8.62765 13.013 8.50151 12.971L5.00649 11.8052L2.32066 12.7004C2.13583 12.762 1.93902 12.7788 1.74645 12.7494C1.55387 12.72 1.37103 12.6452 1.21299 12.5313C1.05496 12.4174 0.926239 12.2676 0.837445 12.0942C0.748651 11.9208 0.702321 11.7288 0.702271 11.534V4.22113C0.702208 3.96292 0.783422 3.71124 0.9344 3.50177C1.08538 3.2923 1.29846 3.13566 1.54344 3.05407L4.81218 1.96449V1.9651ZM5.62138 10.7143L8.08093 11.5346V4.22113L5.62138 3.40087V10.7143ZM4.3916 3.40148L1.93205 4.22174V11.534L4.3916 10.7137V3.40148ZM9.31071 4.22174V11.534L11.7703 10.7137V3.40148L9.31071 4.22174Z"
        fill="#5546A9"
      />
    </svg>
  );
}

export function BuildingIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="4.5" y="6.5" width="8" height="6" rx="0.5" stroke="#5546A9" />
      <rect x="1" y="2" width="9" height="11" rx="1" fill="#5546A9" />
      <rect x="3" y="4" width="5" height="1.6" rx="0.4" fill="white" />
      <rect x="3" y="7" width="4" height="1.6" rx="0.4" fill="white" />
    </svg>
  );
}

export function InfomationIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00002 14C10.866 14 14 10.866 14 7.00002C14 3.13402 10.866 0 7.00002 0C3.13402 0 0 3.13402 0 7.00002C0 10.866 3.13402 14 7.00002 14Z"
        fill="#5546A9"
      />
      <path
        d="M6.48691 10.4922L6.12534 6.16288L7.86743 6.16288L7.50588 10.4922L6.48691 10.4922ZM6.99639 5.41383C6.49512 5.41383 6.12534 5.04404 6.12534 4.54278C6.12534 4.04152 6.49512 3.67995 6.99639 3.67995C7.49765 3.67995 7.86743 4.04152 7.86743 4.54278C7.86743 5.04404 7.49765 5.41383 6.99639 5.41383Z"
        fill="white"
      />
    </svg>
  );
}

export function WarningIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.36364 17.364C13.9828 17.364 17.7273 13.6195 17.7273 9.00036C17.7273 4.38125 13.9828 0.636719 9.36364 0.636719C4.74453 0.636719 1 4.38125 1 9.00036C1 13.6195 4.74453 17.364 9.36364 17.364Z"
        fill="#D22259"
      />
      <path
        d="M9.88656 10.3851H8.66911L8.21747 5.03416H10.3382L9.88656 10.3851ZM9.27784 11.1018C9.57893 11.1018 9.82765 11.2 10.024 11.3963C10.2204 11.5927 10.3186 11.8414 10.3186 12.1425C10.3186 12.4436 10.2204 12.6891 10.024 12.8789C9.82765 13.0753 9.57893 13.1734 9.27784 13.1734C8.97674 13.1734 8.72802 13.0753 8.53165 12.8789C8.33529 12.6891 8.23711 12.4436 8.23711 12.1425C8.23711 11.8414 8.33529 11.5927 8.53165 11.3963C8.72802 11.2 8.97674 11.1018 9.27784 11.1018Z"
        fill="white"
      />
    </svg>
  );
}

export function DoneIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.36364 17.364C13.9828 17.364 17.7273 13.6195 17.7273 9.00036C17.7273 4.38125 13.9828 0.636719 9.36364 0.636719C4.74453 0.636719 1 4.38125 1 9.00036C1 13.6195 4.74453 17.364 9.36364 17.364Z"
        fill="#25B5BE"
      />
      <path
        d="M13.7204 5.41383C13.8228 5.50492 13.8848 5.63291 13.8928 5.76969C13.9009 5.90647 13.8543 6.04085 13.7633 6.14331L8.24907 12.3472C8.20057 12.4018 8.14105 12.4455 8.07444 12.4754C8.00783 12.5053 7.93564 12.5208 7.86262 12.5208C7.7896 12.5208 7.71741 12.5053 7.6508 12.4754C7.58419 12.4455 7.52467 12.4018 7.47617 12.3472L4.71904 9.24527C4.63328 9.14211 4.59098 9.00965 4.60108 8.87588C4.61117 8.7421 4.67286 8.61749 4.77313 8.52837C4.8734 8.43924 5.00438 8.39258 5.13842 8.39824C5.27245 8.4039 5.39904 8.46144 5.49143 8.5587L7.86236 11.2259L12.9909 5.45623C13.0821 5.35394 13.2101 5.29202 13.3469 5.28407C13.4837 5.27613 13.618 5.3228 13.7204 5.41383Z"
        fill="white"
        stroke="white"
        strokeWidth="0.6"
      />
    </svg>
  );
}

export function OneStarIcon() {
  return (
    <svg
      width="36"
      height="10"
      viewBox="0 0 36 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.81747 6.20074L0.843775 3.87873L3.64494 3.65059C3.79878 3.63806 3.9331 3.5415 3.99399 3.39966L5 1.05624L6.00601 3.39966C6.0669 3.5415 6.20122 3.63806 6.35506 3.65059L9.15623 3.87873L7.18253 6.20074C7.09673 6.30168 7.06404 6.4374 7.09448 6.56634L7.71683 9.20216L5.19495 7.86705C5.073 7.80249 4.927 7.80249 4.80505 7.86705L2.28317 9.20216L2.90552 6.56634C2.93596 6.4374 2.90327 6.30168 2.81747 6.20074Z"
        fill="#5546A9"
        stroke="#5546A9"
        strokeWidth="0.833333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8175 6.20074L13.8438 3.87873L16.6449 3.65059C16.7988 3.63806 16.9331 3.5415 16.994 3.39966L18 1.05624L19.006 3.39966C19.0669 3.5415 19.2012 3.63806 19.3551 3.65059L22.1562 3.87873L20.1825 6.20074C20.0967 6.30168 20.064 6.4374 20.0945 6.56634L20.7168 9.20216L18.195 7.86705C18.073 7.80249 17.927 7.80249 17.805 7.86705L15.2832 9.20216L15.9055 6.56634C15.936 6.4374 15.9033 6.30168 15.8175 6.20074Z"
        stroke="#5546A9"
        strokeWidth="0.833333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.8175 6.20074L26.8438 3.87873L29.6449 3.65059C29.7988 3.63806 29.9331 3.5415 29.994 3.39966L31 1.05624L32.006 3.39966C32.0669 3.5415 32.2012 3.63806 32.3551 3.65059L35.1562 3.87873L33.1825 6.20074C33.0967 6.30168 33.064 6.4374 33.0945 6.56634L33.7168 9.20216L31.195 7.86705C31.073 7.80249 30.927 7.80249 30.805 7.86705L28.2832 9.20216L28.9055 6.56634C28.936 6.4374 28.9033 6.30168 28.8175 6.20074Z"
        stroke="#5546A9"
        strokeWidth="0.833333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TwoStarIcon() {
  return (
    <svg
      width="36"
      height="10"
      viewBox="0 0 36 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.81747 6.20074L0.843775 3.87873L3.64494 3.65059C3.79878 3.63806 3.9331 3.5415 3.99399 3.39966L5 1.05624L6.00601 3.39966C6.0669 3.5415 6.20122 3.63806 6.35506 3.65059L9.15623 3.87873L7.18253 6.20074C7.09673 6.30168 7.06404 6.4374 7.09448 6.56634L7.71683 9.20216L5.19495 7.86705C5.073 7.80249 4.927 7.80249 4.80505 7.86705L2.28317 9.20216L2.90552 6.56634C2.93596 6.4374 2.90327 6.30168 2.81747 6.20074Z"
        fill="#5546A9"
        stroke="#5546A9"
        strokeWidth="0.833333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8175 6.20074L13.8438 3.87873L16.6449 3.65059C16.7988 3.63806 16.9331 3.5415 16.994 3.39966L18 1.05624L19.006 3.39966C19.0669 3.5415 19.2012 3.63806 19.3551 3.65059L22.1562 3.87873L20.1825 6.20074C20.0967 6.30168 20.064 6.4374 20.0945 6.56634L20.7168 9.20216L18.195 7.86705C18.073 7.80249 17.927 7.80249 17.805 7.86705L15.2832 9.20216L15.9055 6.56634C15.936 6.4374 15.9033 6.30168 15.8175 6.20074Z"
        fill="#5546A9"
        stroke="#5546A9"
        strokeWidth="0.833333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.8175 6.20074L26.8438 3.87873L29.6449 3.65059C29.7988 3.63806 29.9331 3.5415 29.994 3.39966L31 1.05624L32.006 3.39966C32.0669 3.5415 32.2012 3.63806 32.3551 3.65059L35.1562 3.87873L33.1825 6.20074C33.0967 6.30168 33.064 6.4374 33.0945 6.56634L33.7168 9.20216L31.195 7.86705C31.073 7.80249 30.927 7.80249 30.805 7.86705L28.2832 9.20216L28.9055 6.56634C28.936 6.4374 28.9033 6.30168 28.8175 6.20074Z"
        stroke="#5546A9"
        strokeWidth="0.833333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ThreeStarIcon() {
  return (
    <svg
      width="36"
      height="10"
      viewBox="0 0 36 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.81747 6.20074L0.843775 3.87873L3.64494 3.65059C3.79878 3.63806 3.9331 3.5415 3.99399 3.39966L5 1.05624L6.00601 3.39966C6.0669 3.5415 6.20122 3.63806 6.35506 3.65059L9.15623 3.87873L7.18253 6.20074C7.09673 6.30168 7.06404 6.4374 7.09448 6.56634L7.71683 9.20216L5.19495 7.86705C5.073 7.80249 4.927 7.80249 4.80505 7.86705L2.28317 9.20216L2.90552 6.56634C2.93596 6.4374 2.90327 6.30168 2.81747 6.20074Z"
        fill="#5546A9"
        stroke="#5546A9"
        strokeWidth="0.833333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8175 6.20074L13.8438 3.87873L16.6449 3.65059C16.7988 3.63806 16.9331 3.5415 16.994 3.39966L18 1.05624L19.006 3.39966C19.0669 3.5415 19.2012 3.63806 19.3551 3.65059L22.1562 3.87873L20.1825 6.20074C20.0967 6.30168 20.064 6.4374 20.0945 6.56634L20.7168 9.20216L18.195 7.86705C18.073 7.80249 17.927 7.80249 17.805 7.86705L15.2832 9.20216L15.9055 6.56634C15.936 6.4374 15.9033 6.30168 15.8175 6.20074Z"
        fill="#5546A9"
        stroke="#5546A9"
        strokeWidth="0.833333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.8175 6.20074L26.8438 3.87873L29.6449 3.65059C29.7988 3.63806 29.9331 3.5415 29.994 3.39966L31 1.05624L32.006 3.39966C32.0669 3.5415 32.2012 3.63806 32.3551 3.65059L35.1562 3.87873L33.1825 6.20074C33.0967 6.30168 33.064 6.4374 33.0945 6.56634L33.7168 9.20216L31.195 7.86705C31.073 7.80249 30.927 7.80249 30.805 7.86705L28.2832 9.20216L28.9055 6.56634C28.936 6.4374 28.9033 6.30168 28.8175 6.20074Z"
        fill="#5546A9"
        stroke="#5546A9"
        strokeWidth="0.833333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function EditIcon() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6123 6.12776C15.7549 5.98515 15.9484 5.90503 16.1501 5.90503C16.3518 5.90503 16.5453 5.98515 16.688 6.12776L19.7308 9.17065C19.8735 9.31331 19.9536 9.50677 19.9536 9.70848C19.9536 9.9102 19.8735 10.1037 19.7308 10.2463L9.84145 20.1357C9.69882 20.2784 9.50536 20.3586 9.30362 20.3586H6.26072C6.05897 20.3586 5.86547 20.2785 5.72281 20.1358C5.58015 19.9931 5.5 19.7996 5.5 19.5979V16.555C5.50004 16.3533 5.58022 16.1598 5.72289 16.0172L13.3301 8.40993L15.6123 6.12776ZM13.868 10.0234L7.02145 16.8699V18.8372H8.98868L15.8352 11.9907L13.868 10.0234ZM16.9108 10.915L18.1174 9.70848L16.1501 7.74125L14.9436 8.94776L16.9108 10.915Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function DeleteIcon() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.06082 6.52936C8.06082 6.09856 8.23195 5.6854 8.53657 5.38078C8.84119 5.07616 9.25435 4.90503 9.68514 4.90503H14.5581C14.9889 4.90503 15.4021 5.07616 15.7067 5.38078C16.0113 5.6854 16.1825 6.09856 16.1825 6.52936V8.15368H19.4311C19.6465 8.15368 19.8531 8.23925 20.0054 8.39156C20.1577 8.54387 20.2433 8.75045 20.2433 8.96585C20.2433 9.18125 20.1577 9.38782 20.0054 9.54013C19.8531 9.69244 19.6465 9.77801 19.4311 9.77801H18.5629L17.8588 19.6393C17.8296 20.0491 17.6462 20.4326 17.3456 20.7126C17.0449 20.9926 16.6493 21.1483 16.2385 21.1483H8.00397C7.59312 21.1483 7.19754 20.9926 6.89689 20.7126C6.59625 20.4326 6.41287 20.0491 6.3837 19.6393L5.68118 9.77801H4.81216C4.59676 9.77801 4.39019 9.69244 4.23788 9.54013C4.08557 9.38782 4 9.18125 4 8.96585C4 8.75045 4.08557 8.54387 4.23788 8.39156C4.39019 8.23925 4.59676 8.15368 4.81216 8.15368H8.06082V6.52936ZM9.68514 8.15368H14.5581V6.52936H9.68514V8.15368ZM7.30875 9.77801L8.00478 19.524H16.2393L16.9353 9.77801H7.30875ZM10.4973 11.4023C10.7127 11.4023 10.9193 11.4879 11.0716 11.6402C11.2239 11.7925 11.3095 11.9991 11.3095 12.2145V17.0875C11.3095 17.3029 11.2239 17.5095 11.0716 17.6618C10.9193 17.8141 10.7127 17.8996 10.4973 17.8996C10.2819 17.8996 10.0753 17.8141 9.92302 17.6618C9.77071 17.5095 9.68514 17.3029 9.68514 17.0875V12.2145C9.68514 11.9991 9.77071 11.7925 9.92302 11.6402C10.0753 11.4879 10.2819 11.4023 10.4973 11.4023ZM13.746 11.4023C13.9614 11.4023 14.1679 11.4879 14.3202 11.6402C14.4726 11.7925 14.5581 11.9991 14.5581 12.2145V17.0875C14.5581 17.3029 14.4726 17.5095 14.3202 17.6618C14.1679 17.8141 13.9614 17.8996 13.746 17.8996C13.5306 17.8996 13.324 17.8141 13.1717 17.6618C13.0194 17.5095 12.9338 17.3029 12.9338 17.0875V12.2145C12.9338 11.9991 13.0194 11.7925 13.1717 11.6402C13.324 11.4879 13.5306 11.4023 13.746 11.4023Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function GoBackIcon() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7818 5.13782C11.931 5.28707 12.0148 5.48947 12.0148 5.70051C12.0148 5.91155 11.931 6.11394 11.7818 6.26319L10.7527 7.29226H12.015C15.7174 7.29226 18.7799 10.3548 18.7799 14.0572C18.7799 17.7596 15.7174 20.8222 12.015 20.8222C8.31254 20.8222 5.25 17.7596 5.25 14.0572C5.25 13.8461 5.33385 13.6437 5.48311 13.4945C5.63236 13.3452 5.8348 13.2613 6.04588 13.2613C6.25696 13.2613 6.45939 13.3452 6.60865 13.4945C6.7579 13.6437 6.84175 13.8461 6.84175 14.0572C6.84175 16.881 9.19118 19.2304 12.015 19.2304C14.8387 19.2304 17.1882 16.881 17.1882 14.0572C17.1882 11.2334 14.8387 8.88402 12.015 8.88402H10.7527L11.7818 9.91309C11.9267 10.0632 12.007 10.2642 12.0051 10.4729C12.0033 10.6816 11.9196 10.8812 11.7721 11.0288C11.6245 11.1763 11.4249 11.26 11.2162 11.2618C11.0075 11.2637 10.8065 11.1834 10.6564 11.0385L8.26876 8.65083C8.11956 8.50158 8.03574 8.29918 8.03574 8.08814C8.03574 7.8771 8.11956 7.6747 8.26876 7.52545L10.6564 5.13782C10.8056 4.98862 11.008 4.9048 11.2191 4.9048C11.4301 4.9048 11.6325 4.98862 11.7818 5.13782Z"
        fill="#5546A9"
      />
    </svg>
  );
}

export function ThreeStar() {
  return (
    <svg
      width="58"
      height="16"
      viewBox="0 0 58 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.90835 9.92118L1.75043 6.20598L6.23229 5.84094C6.47844 5.82089 6.69335 5.6664 6.79077 5.43946L8.40039 1.68999L10.01 5.43946C10.1074 5.6664 10.3223 5.82089 10.5685 5.84094L15.0504 6.20598L11.8924 9.92118C11.7552 10.0827 11.7029 10.2998 11.7516 10.5061L12.7473 14.7235L8.71232 12.5873C8.51719 12.484 8.28359 12.484 8.08847 12.5873L4.05346 14.7235L5.04922 10.5061C5.09793 10.2998 5.04563 10.0827 4.90835 9.92118Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.7072 9.92118L22.5493 6.20598L27.0311 5.84094C27.2773 5.82089 27.4922 5.6664 27.5896 5.43946L29.1992 1.68999L30.8088 5.43946C30.9063 5.6664 31.1212 5.82089 31.3673 5.84094L35.8492 6.20598L32.6913 9.92118C32.554 10.0827 32.5017 10.2998 32.5504 10.5061L33.5461 14.7235L29.5111 12.5873C29.316 12.484 29.0824 12.484 28.8873 12.5873L24.8523 14.7235L25.848 10.5061C25.8968 10.2998 25.8445 10.0827 25.7072 9.92118Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.508 9.92118L43.35 6.20598L47.8319 5.84094C48.0781 5.82089 48.293 5.6664 48.3904 5.43946L50 1.68999L51.6096 5.43946C51.707 5.6664 51.9219 5.82089 52.1681 5.84094L56.65 6.20598L53.492 9.92118C53.3548 10.0827 53.3025 10.2998 53.3512 10.5061L54.3469 14.7235L50.3119 12.5873C50.1168 12.484 49.8832 12.484 49.6881 12.5873L45.6531 14.7235L46.6488 10.5061C46.6975 10.2998 46.6452 10.0827 46.508 9.92118Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TwoStar() {
  return (
    <svg
      width="37"
      height="16"
      viewBox="0 0 37 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.70718 9.92118L1.54926 6.20598L6.03112 5.84094C6.27727 5.82089 6.49217 5.6664 6.5896 5.43946L8.19922 1.68999L9.80884 5.43946C9.90626 5.6664 10.1212 5.82089 10.3673 5.84094L14.8492 6.20598L11.6913 9.92118C11.554 10.0827 11.5017 10.2998 11.5504 10.5061L12.5461 14.7235L8.51114 12.5873C8.31602 12.484 8.08242 12.484 7.88729 12.5873L3.85229 14.7235L4.84805 10.5061C4.89675 10.2998 4.84446 10.0827 4.70718 9.92118Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.508 9.92118L22.35 6.20598L26.8319 5.84094C27.0781 5.82089 27.293 5.6664 27.3904 5.43946L29 1.68999L30.6096 5.43946C30.707 5.6664 30.9219 5.82089 31.1681 5.84094L35.65 6.20598L32.492 9.92118C32.3548 10.0827 32.3025 10.2998 32.3512 10.5061L33.3469 14.7235L29.3119 12.5873C29.1168 12.484 28.8832 12.484 28.6881 12.5873L24.6531 14.7235L25.6488 10.5061C25.6975 10.2998 25.6452 10.0827 25.508 9.92118Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function OneStar() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.50796 9.92118L1.35004 6.20598L5.8319 5.84094C6.07805 5.82089 6.29296 5.6664 6.39038 5.43946L8 1.68999L9.60962 5.43946C9.70704 5.6664 9.92195 5.82089 10.1681 5.84094L14.65 6.20598L11.492 9.92118C11.3548 10.0827 11.3025 10.2998 11.3512 10.5061L12.3469 14.7235L8.31192 12.5873C8.1168 12.484 7.8832 12.484 7.68808 12.5873L3.65307 14.7235L4.64883 10.5061C4.69753 10.2998 4.64524 10.0827 4.50796 9.92118Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function A() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.048 13.44L9.136 10.912H4.08L3.168 13.44H0.16L5.216 0.4H8.24L13.296 13.44H10.048ZM4.976 8.384H8.24L6.608 3.84L4.976 8.384Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function B() {
  return (
    <svg
      width="11"
      height="14"
      viewBox="0 0 11 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.152 13.44V0.4H5.816C8.712 0.4 10.344 1.904 10.344 4.288C10.344 5.216 9.72 6.272 8.824 6.608C10.072 7.008 10.952 8.224 10.952 9.488C10.952 11.904 9.224 13.44 6.296 13.44H0.152ZM3.064 5.68H5.688C6.792 5.68 7.432 5.2 7.432 4.288C7.432 3.376 6.792 2.88 5.688 2.88H3.064V5.68ZM3.064 10.96H6.168C7.32 10.96 8.04 10.448 8.04 9.488C8.04 8.528 7.32 8.016 6.168 8.016H3.064V10.96Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function C() {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.552 13.76C3.536 13.76 0.576 10.864 0.576 6.912C0.576 2.96 3.536 0.0639992 7.552 0.0639992C11.136 0.0639992 13.536 2.224 14.064 4.976H11.12C10.816 3.728 9.488 2.736 7.616 2.736C5.248 2.736 3.488 4.48 3.488 6.912C3.488 9.328 5.248 11.088 7.616 11.088C9.488 11.088 11.024 9.856 11.248 8.672H14.192C13.792 11.296 11.168 13.76 7.552 13.76Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function MoreInformation() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4ZM2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12Z"
          fill="#0D0D0D"
        />
        <path
          d="M12 13.9998C11.7348 13.9998 11.4804 13.8944 11.2929 13.7069C11.1054 13.5193 11 13.265 11 12.9998V11.9998C11 11.7345 11.1054 11.4802 11.2929 11.2926C11.4804 11.1051 11.7348 10.9998 12 10.9998C12.2652 10.9998 12.5196 11.1051 12.7071 11.2926C12.8946 11.4802 13 11.7345 13 11.9998V12.9998C13 13.265 12.8946 13.5193 12.7071 13.7069C12.5196 13.8944 12.2652 13.9998 12 13.9998ZM10.5 16.4998C10.5 16.1019 10.658 15.7204 10.9393 15.4391C11.2206 15.1578 11.6022 14.9998 12 14.9998C12.3978 14.9998 12.7794 15.1578 13.0607 15.4391C13.342 15.7204 13.5 16.1019 13.5 16.4998C13.5 16.8976 13.342 17.2791 13.0607 17.5604C12.7794 17.8417 12.3978 17.9998 12 17.9998C11.6022 17.9998 11.2206 17.8417 10.9393 17.5604C10.658 17.2791 10.5 16.8976 10.5 16.4998Z"
          fill="#0D0D0D"
        />
        <path
          d="M12.389 7.81091C11.432 7.76591 10.629 8.30091 10.485 9.16391C10.4346 9.41898 10.2869 9.64441 10.0731 9.7924C9.85932 9.94038 9.59631 9.99929 9.33984 9.95663C9.08336 9.91397 8.85358 9.7731 8.69922 9.56388C8.54486 9.35466 8.47805 9.09355 8.51297 8.83591C8.86897 6.69991 10.816 5.73391 12.484 5.81391C13.338 5.85391 14.217 6.16091 14.893 6.79291C15.586 7.43991 15.999 8.36791 15.999 9.49991C15.999 10.7909 15.491 11.7489 14.616 12.3319C13.813 12.8669 12.828 12.9999 11.999 12.9999C11.7337 12.9999 11.4794 12.8946 11.2919 12.707C11.1043 12.5195 10.999 12.2651 10.999 11.9999C10.999 11.7347 11.1043 11.4803 11.2919 11.2928C11.4794 11.1053 11.7337 10.9999 11.999 10.9999C12.669 10.9999 13.185 10.8829 13.507 10.6679C13.757 10.5009 13.999 10.2079 13.999 9.49991C13.999 8.88191 13.787 8.49691 13.527 8.25391C13.25 7.99491 12.847 7.83391 12.389 7.81091Z"
          fill="#0D0D0D"
        />
      </g>
    </svg>
  );
}

export function UploadIcon() {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6296 8.13307C15.0426 8.13302 14.4614 8.2505 13.9205 8.47858C13.3796 8.70666 12.8898 9.04072 12.48 9.46107C12.0702 9.88142 11.7487 10.3796 11.5344 10.9261C11.3202 11.4727 11.2175 12.0566 11.2325 12.6435C11.2384 12.8917 11.1601 13.1346 11.0103 13.3326C10.8606 13.5307 10.6482 13.6722 10.4078 13.7342C9.63265 13.9373 8.95782 14.4154 8.50919 15.0793C8.06056 15.7432 7.86877 16.5477 7.96958 17.3427C8.0704 18.1376 8.45694 18.8687 9.0571 19.3997C9.65727 19.9306 10.4301 20.2251 11.2314 20.2282H12.3309C12.6226 20.2282 12.9022 20.3441 13.1084 20.5503C13.3146 20.7565 13.4305 21.0362 13.4305 21.3278C13.4305 21.6194 13.3146 21.8991 13.1084 22.1053C12.9022 22.3115 12.6226 22.4273 12.3309 22.4273H11.2314C9.96502 22.4276 8.7374 21.9907 7.75595 21.1904C6.7745 20.3902 6.09941 19.2756 5.84475 18.0351C5.59008 16.7947 5.77146 15.5043 6.35824 14.3821C6.94502 13.2599 7.90121 12.3746 9.06524 11.876C9.2039 10.4862 9.78004 9.17629 10.7107 8.13487C11.6414 7.09345 12.8785 6.37425 14.244 6.08083C15.6095 5.78741 17.0329 5.93492 18.3092 6.5021C19.5855 7.06929 20.6489 8.0269 21.3462 9.23702C23.0722 9.29983 24.7047 10.037 25.8932 11.2901C27.0817 12.5433 27.7314 14.2126 27.7027 15.9394C27.6741 17.6663 26.9694 19.3131 25.74 20.5262C24.5106 21.7392 22.8545 22.4218 21.1274 22.4273C20.8358 22.4273 20.5561 22.3115 20.3499 22.1053C20.1437 21.8991 20.0278 21.6194 20.0278 21.3278C20.0278 21.0362 20.1437 20.7565 20.3499 20.5503C20.5561 20.3441 20.8358 20.2282 21.1274 20.2282C21.7196 20.2274 22.3056 20.1069 22.8502 19.8741C23.3947 19.6412 23.8866 19.3008 24.2964 18.8732C24.7062 18.4456 25.0254 17.9397 25.2349 17.3858C25.4444 16.8318 25.5398 16.2413 25.5155 15.6495C25.4912 15.0578 25.3477 14.477 25.0935 13.9421C24.8393 13.4072 24.4796 12.9292 24.0362 12.5366C23.5927 12.1441 23.0745 11.8451 22.5127 11.6577C21.9509 11.4703 21.3571 11.3983 20.7667 11.446C20.5377 11.4647 20.3085 11.411 20.1115 11.2927C19.9145 11.1744 19.7595 10.9973 19.6683 10.7863C19.3275 9.99817 18.7635 9.327 18.0458 8.85554C17.3282 8.38407 16.4883 8.13293 15.6296 8.13307ZM15.9518 13.953C16.158 13.7469 16.4376 13.6311 16.7292 13.6311C17.0207 13.6311 17.3004 13.7469 17.5066 13.953L19.7057 16.1521C19.906 16.3595 20.0168 16.6373 20.0143 16.9256C20.0118 17.2139 19.8961 17.4897 19.6923 17.6935C19.4884 17.8974 19.2126 18.013 18.9243 18.0155C18.636 18.018 18.3583 17.9072 18.1509 17.7069L17.8287 17.3848V25.726C17.8287 26.0176 17.7129 26.2973 17.5067 26.5035C17.3005 26.7097 17.0208 26.8256 16.7292 26.8256C16.4375 26.8256 16.1579 26.7097 15.9517 26.5035C15.7455 26.2973 15.6296 26.0176 15.6296 25.726V17.3848L15.3074 17.7069C15.1001 17.9072 14.8223 18.018 14.534 18.0155C14.2457 18.013 13.9699 17.8974 13.7661 17.6935C13.5622 17.4897 13.4465 17.2139 13.444 16.9256C13.4415 16.6373 13.5524 16.3595 13.7527 16.1521L15.9518 13.953Z"
        fill="#5546A9"
      />
    </svg>
  );
}

export function LogoutIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 6.75C4 6.28587 4.17911 5.84075 4.49792 5.51256C4.81674 5.18437 5.24915 5 5.70002 5H13.3501C13.801 5 14.2334 5.18437 14.5522 5.51256C14.871 5.84075 15.0501 6.28587 15.0501 6.75V8.5C15.0501 8.73206 14.9606 8.95462 14.8012 9.11872C14.6417 9.28281 14.4255 9.375 14.2001 9.375C13.9747 9.375 13.7585 9.28281 13.5991 9.11872C13.4397 8.95462 13.3501 8.73206 13.3501 8.5V6.75H5.70002V17.25H13.3501V15.5C13.3501 15.2679 13.4397 15.0454 13.5991 14.8813C13.7585 14.7172 13.9747 14.625 14.2001 14.625C14.4255 14.625 14.6417 14.7172 14.8012 14.8813C14.9606 15.0454 15.0501 15.2679 15.0501 15.5V17.25C15.0501 17.7141 14.871 18.1592 14.5522 18.4874C14.2334 18.8156 13.801 19 13.3501 19H5.70002C5.24915 19 4.81674 18.8156 4.49792 18.4874C4.17911 18.1592 4 17.7141 4 17.25V6.75ZM16.9992 8.75638C17.1586 8.59234 17.3748 8.50019 17.6001 8.50019C17.8255 8.50019 18.0417 8.59234 18.2011 8.75638L20.7511 11.3814C20.9105 11.5455 21 11.768 21 12C21 12.232 20.9105 12.4545 20.7511 12.6186L18.2011 15.2436C18.0408 15.403 17.8261 15.4912 17.6032 15.4892C17.3803 15.4872 17.1671 15.3952 17.0095 15.233C16.8519 15.0707 16.7625 14.8513 16.7606 14.6219C16.7587 14.3924 16.8444 14.1714 16.9992 14.0064L18.0982 12.875H9.95006C9.72463 12.875 9.50842 12.7828 9.34902 12.6187C9.18961 12.4546 9.10005 12.2321 9.10005 12C9.10005 11.7679 9.18961 11.5454 9.34902 11.3813C9.50842 11.2172 9.72463 11.125 9.95006 11.125H18.0982L16.9992 9.99362C16.8398 9.82954 16.7503 9.60702 16.7503 9.375C16.7503 9.14298 16.8398 8.92046 16.9992 8.75638Z"
        fill="#5546A9"
      />
    </svg>
  );
}

export function AddButtonIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 6V18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M18 12L6 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function DownloadIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.435 4C12.6484 4 12.853 4.08475 13.0038 4.2356C13.1547 4.38645 13.2394 4.59104 13.2394 4.80438V13.3195L15.0839 11.4751C15.2356 11.3286 15.4388 11.2475 15.6497 11.2493C15.8606 11.2512 16.0623 11.3358 16.2115 11.4849C16.3606 11.634 16.4452 11.8358 16.447 12.0467C16.4489 12.2576 16.3678 12.4608 16.2213 12.6125L13.0037 15.83C12.8529 15.9808 12.6483 16.0655 12.435 16.0655C12.2217 16.0655 12.0172 15.9808 11.8663 15.83L8.64882 12.6125C8.572 12.5383 8.51072 12.4495 8.46856 12.3514C8.4264 12.2533 8.40421 12.1477 8.40329 12.0409C8.40236 11.9341 8.42271 11.8282 8.46315 11.7293C8.5036 11.6305 8.56333 11.5407 8.63885 11.4651C8.71438 11.3896 8.80419 11.3299 8.90304 11.2894C9.0019 11.249 9.10782 11.2286 9.21462 11.2296C9.32143 11.2305 9.42698 11.2527 9.52512 11.2948C9.62325 11.337 9.71201 11.3983 9.78621 11.4751L11.6307 13.3195V4.80438C11.6307 4.59104 11.7154 4.38645 11.8663 4.2356C12.0171 4.08475 12.2217 4 12.435 4ZM6.80438 16.0657C7.01771 16.0657 7.22231 16.1504 7.37316 16.3013C7.52401 16.4521 7.60876 16.6567 7.60876 16.8701V18.4788H17.2613V16.8701C17.2613 16.6567 17.3461 16.4521 17.4969 16.3013C17.6478 16.1504 17.8524 16.0657 18.0657 16.0657C18.279 16.0657 18.4836 16.1504 18.6345 16.3013C18.7853 16.4521 18.8701 16.6567 18.8701 16.8701V18.4788C18.8701 18.9055 18.7006 19.3147 18.3989 19.6164C18.0972 19.9181 17.688 20.0876 17.2613 20.0876H7.60876C7.18209 20.0876 6.7729 19.9181 6.47119 19.6164C6.16949 19.3147 6 18.9055 6 18.4788V16.8701C6 16.6567 6.08475 16.4521 6.2356 16.3013C6.38645 16.1504 6.59104 16.0657 6.80438 16.0657Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function TypeCategoryIcon() {
  return (
    <svg
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M61.625 50.9997H53.125V44.6247H59.5C59.8229 44.6246 60.1415 44.551 60.4317 44.4094C60.7219 44.2678 60.976 44.0619 61.1747 43.8074C61.3734 43.5528 61.5115 43.2564 61.5785 42.9405C61.6454 42.6246 61.6395 42.2976 61.5612 41.9844L53.0612 7.98438C52.9461 7.5249 52.6807 7.11706 52.3073 6.82566C51.9338 6.53425 51.4737 6.37598 51 6.37598C50.5263 6.37598 50.0662 6.53425 49.6927 6.82566C49.3193 7.11706 49.0539 7.5249 48.9388 7.98438L40.4388 41.9844C40.3605 42.2976 40.3546 42.6246 40.4215 42.9405C40.4885 43.2564 40.6266 43.5528 40.8253 43.8074C41.024 44.0619 41.2781 44.2678 41.5683 44.4094C41.8585 44.551 42.1771 44.6246 42.5 44.6247H48.875V50.9997H31.875V46.7497H34C34.5636 46.7497 35.1041 46.5258 35.5026 46.1273C35.9011 45.7288 36.125 45.1883 36.125 44.6247C36.125 44.0611 35.9011 43.5206 35.5026 43.1221C35.1041 42.7236 34.5636 42.4997 34 42.4997H31.875V38.2497H34C34.5636 38.2497 35.1041 38.0258 35.5026 37.6273C35.9011 37.2288 36.125 36.6883 36.125 36.1247C36.125 35.5611 35.9011 35.0206 35.5026 34.6221C35.1041 34.2236 34.5636 33.9997 34 33.9997H10.625C10.0614 33.9997 9.52091 34.2236 9.1224 34.6221C8.72388 35.0206 8.5 35.5611 8.5 36.1247C8.5 36.6883 8.72388 37.2288 9.1224 37.6273C9.52091 38.0258 10.0614 38.2497 10.625 38.2497H12.75V42.4997H10.625C10.0614 42.4997 9.52091 42.7236 9.1224 43.1221C8.72388 43.5206 8.5 44.0611 8.5 44.6247C8.5 45.1883 8.72388 45.7288 9.1224 46.1273C9.52091 46.5258 10.0614 46.7497 10.625 46.7497H12.75V50.9997H6.375C5.81141 50.9997 5.27091 51.2236 4.8724 51.6221C4.47388 52.0206 4.25 52.5611 4.25 53.1247C4.25 53.6883 4.47388 54.2288 4.8724 54.6273C5.27091 55.0258 5.81141 55.2497 6.375 55.2497H61.625C62.1886 55.2497 62.7291 55.0258 63.1276 54.6273C63.5261 54.2288 63.75 53.6883 63.75 53.1247C63.75 52.5611 63.5261 52.0206 63.1276 51.6221C62.7291 51.2236 62.1886 50.9997 61.625 50.9997ZM27.625 50.9997H17V46.7497H27.625V50.9997ZM27.625 42.4997H17V38.2497H27.625V42.4997ZM30.8125 25.4997C32.2835 25.4997 33.7215 25.0635 34.9446 24.2462C36.1676 23.429 37.1209 22.2674 37.6839 20.9084C38.2468 19.5494 38.3941 18.0539 38.1071 16.6112C37.8201 15.1685 37.1118 13.8432 36.0716 12.8031C35.0315 11.7629 33.7062 11.0546 32.2635 10.7676C30.8208 10.4806 29.3253 10.6279 27.9663 11.1908C26.6073 11.7538 25.4457 12.707 24.6284 13.9301C23.8112 15.1532 23.375 16.5912 23.375 18.0622C23.375 20.0347 24.1586 21.9265 25.5534 23.3213C26.9482 24.7161 28.84 25.4997 30.8125 25.4997ZM30.8125 14.8747C31.4429 14.8747 32.0592 15.0616 32.5834 15.4119C33.1076 15.7621 33.5161 16.2599 33.7574 16.8424C33.9986 17.4248 34.0617 18.0657 33.9388 18.684C33.8158 19.3024 33.5122 19.8703 33.0664 20.3161C32.6206 20.7619 32.0527 21.0655 31.4344 21.1884C30.816 21.3114 30.1751 21.2483 29.5927 21.0071C29.0103 20.7658 28.5124 20.3573 28.1622 19.8331C27.8119 19.3089 27.625 18.6926 27.625 18.0622C27.625 17.2168 27.9608 16.4061 28.5586 15.8083C29.1564 15.2105 29.9671 14.8747 30.8125 14.8747Z"
        fill="#5546A9"
      />
    </svg>
  );
}

export function FacilityCategoryIcon() {
  return (
    <svg
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.0268 43.9824L13.3423 52.6106C12.8314 53.1181 12.2244 53.3617 11.5211 53.3414C10.8178 53.3211 10.2329 53.0775 9.76628 52.6106C9.25543 52.103 9 51.4999 9 50.8012C9 50.1025 9.23414 49.5214 9.70243 49.0578L18.387 40.4297C19.7067 39.1185 20.6117 37.48 21.1022 35.5142C21.5926 33.5483 21.837 30.5344 21.8352 26.4724C21.8352 24.0193 22.3887 21.6085 23.4955 19.24C24.6024 16.8715 26.1775 14.6722 28.2209 12.642C32.0949 8.7932 36.3734 6.61502 41.0562 6.10748C45.739 5.59994 49.5917 6.88993 52.6143 9.97745C55.6794 13.0227 56.9566 16.8715 56.4457 21.5239C55.9349 26.1763 53.7637 30.4058 49.9323 34.2123C47.8889 36.2425 45.6752 37.8074 43.2912 38.9071C40.9072 40.0067 38.4806 40.5566 36.0115 40.5566C31.8821 40.5566 28.8595 40.7892 26.9438 41.2544C25.0281 41.7197 23.3891 42.629 22.0268 43.9824ZM29.1149 33.1973C31.1158 35.1428 33.8191 35.8618 37.2248 35.3543C40.6305 34.8468 43.6743 33.2607 46.3563 30.5961C49.0809 27.8893 50.7097 24.8542 51.2427 21.4909C51.7757 18.1276 51.0409 15.4952 49.0383 13.5937C46.9949 11.5635 44.3231 10.8022 41.023 11.3097C37.7229 11.8173 34.6901 13.4245 31.9246 16.1313C29.2427 18.7959 27.6139 21.8098 27.0383 25.1731C26.4628 28.5364 27.155 31.2111 29.1149 33.1973ZM48.7829 62C45.9732 62 43.5679 61.0061 41.5671 59.0182C39.5662 57.0304 38.5658 54.6407 38.5658 51.8493C38.5658 49.0578 39.5662 46.6681 41.5671 44.6803C43.5679 42.6924 45.9732 41.6985 48.7829 41.6985C51.5926 41.6985 53.9979 42.6924 55.9987 44.6803C57.9996 46.6681 59 49.0578 59 51.8493C59 54.6407 57.9996 57.0304 55.9987 59.0182C53.9979 61.0061 51.5926 62 48.7829 62Z"
        fill="#5546A9"
      />
    </svg>
  );
}

export function StatusCategoryIcon() {
  return (
    <svg
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41.0267 53.0118C38.9504 53.8429 36.6746 54.0405 34.4862 53.5796C32.2978 53.1188 30.2949 52.0202 28.7301 50.4224C27.1653 48.8246 26.1088 46.7992 25.6938 44.6016C25.2788 42.4041 25.5239 40.1329 26.3982 38.0744L33.8187 45.4949L39.8253 39.4854L32.4077 32.0649C34.5001 31.1724 36.8131 30.9322 39.0442 31.3757C41.2754 31.8193 43.3207 32.9259 44.9126 34.5509C46.5045 36.1759 47.5689 38.2435 47.9665 40.4833C48.3641 42.723 48.0764 45.0307 47.141 47.1043L52.6178 52.5811C55.2577 48.7923 56.671 44.2845 56.6667 39.6668C56.626 32.3932 54.9496 25.222 51.7616 18.6842C48.5736 12.1464 43.9558 6.40956 38.25 1.89844C39.4605 6.338 40.1638 10.9004 40.3467 15.4984C40.4473 16.8359 40.2732 18.1799 39.8351 19.4476C39.397 20.7153 38.7041 21.88 37.7991 22.8699C36.894 23.8599 35.796 24.6542 34.5726 25.204C33.3491 25.7537 32.0262 26.0474 30.685 26.0668C29.3113 26.0634 27.9521 25.7857 26.6872 25.2498C25.4223 24.714 24.2772 23.9308 23.3192 22.9463C22.3611 21.9619 21.6093 20.7959 21.108 19.5169C20.6068 18.238 20.366 16.8717 20.4 15.4984L20.485 14.4784C14.5556 21.5304 11.3136 30.4534 11.3333 39.6668C11.3341 43.7669 12.4469 47.79 14.5534 51.3077C16.6598 54.8253 19.6809 57.7057 23.295 59.6421C26.909 61.5785 30.9806 62.4984 35.0761 62.3037C39.1716 62.1091 43.1376 60.8072 46.5517 58.5368L41.0267 53.0118Z"
        fill="#5546A9"
      />
    </svg>
  );
}

export function PartCategoryIcon() {
  return (
    <svg
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.75 15.4375C25.75 13.7965 26.4019 12.2227 27.5623 11.0623C28.7227 9.9019 30.2965 9.25 31.9375 9.25H36.0625C37.7035 9.25 39.2773 9.9019 40.4377 11.0623C41.5981 12.2227 42.25 13.7965 42.25 15.4375V19.5625C42.25 21.2035 41.5981 22.7773 40.4377 23.9377C39.2773 25.0981 37.7035 25.75 36.0625 25.75V29.875H58.75C59.297 29.875 59.8216 30.0923 60.2084 30.4791C60.5952 30.8659 60.8125 31.3905 60.8125 31.9375V36.0625C60.8125 36.6095 60.5952 37.1341 60.2084 37.5209C59.8216 37.9077 59.297 38.125 58.75 38.125C58.203 38.125 57.6784 37.9077 57.2916 37.5209C56.9048 37.1341 56.6875 36.6095 56.6875 36.0625V33.5H36.0625V36.0625C36.0625 36.6095 35.8452 37.1341 35.4584 37.5209C35.0716 37.9077 34.547 38.125 34 38.125C33.453 38.125 32.9284 37.9077 32.5416 37.5209C32.1548 37.1341 31.9375 36.6095 31.9375 36.0625V33.5H11.3125V36.0625C11.3125 36.6095 11.0952 37.1341 10.7084 37.5209C10.3216 37.9077 9.79701 38.125 9.25 38.125C8.70299 38.125 8.17839 37.9077 7.79159 37.5209C7.4048 37.1341 7.1875 36.6095 7.1875 36.0625V31.9375C7.1875 31.3905 7.4048 30.8659 7.79159 30.4791C8.17839 30.0923 8.70299 29.875 9.25 29.875H31.9375V25.75C30.2965 25.75 28.7227 25.0981 27.5623 23.9377C26.4019 22.7773 25.75 21.2035 25.75 19.5625V15.4375ZM1 48.4375C1 46.7965 1.6519 45.2227 2.81228 44.0623C3.97266 42.9019 5.54647 42.25 7.1875 42.25H11.3125C12.9535 42.25 14.5273 42.9019 15.6877 44.0623C16.8481 45.2227 17.5 46.7965 17.5 48.4375V52.5625C17.5 54.2035 16.8481 55.7773 15.6877 56.9377C14.5273 58.0981 12.9535 58.75 11.3125 58.75H7.1875C5.54647 58.75 3.97266 58.0981 2.81228 56.9377C1.6519 55.7773 1 54.2035 1 52.5625L1 48.4375ZM25.75 48.4375C25.75 46.7965 26.4019 45.2227 27.5623 44.0623C28.7227 42.9019 30.2965 42.25 31.9375 42.25H36.0625C37.7035 42.25 39.2773 42.9019 40.4377 44.0623C41.5981 45.2227 42.25 46.7965 42.25 48.4375V52.5625C42.25 54.2035 41.5981 55.7773 40.4377 56.9377C39.2773 58.0981 37.7035 58.75 36.0625 58.75H31.9375C30.2965 58.75 28.7227 58.0981 27.5623 56.9377C26.4019 55.7773 25.75 54.2035 25.75 52.5625V48.4375ZM50.5 48.4375C50.5 46.7965 51.1519 45.2227 52.3123 44.0623C53.4727 42.9019 55.0465 42.25 56.6875 42.25H60.8125C62.4535 42.25 64.0273 42.9019 65.1877 44.0623C66.3481 45.2227 67 46.7965 67 48.4375V52.5625C67 54.2035 66.3481 55.7773 65.1877 56.9377C64.0273 58.0981 62.4535 58.75 60.8125 58.75H56.6875C55.0465 58.75 53.4727 58.0981 52.3123 56.9377C51.1519 55.7773 50.5 54.2035 50.5 52.5625V48.4375Z"
        fill="#5546A9"
      />
    </svg>
  );
}

export function ImageIcon() {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.1145 11.5438C24.7959 11.8624 24.3638 12.0414 23.9132 12.0414C23.4626 12.0414 23.0305 11.8624 22.7118 11.5438C22.3932 11.2252 22.2142 10.7931 22.2142 10.3425C22.2142 9.89191 22.3932 9.45978 22.7118 9.14116C23.0305 8.82255 23.4626 8.64355 23.9132 8.64355C24.3638 8.64355 24.7959 8.82255 25.1145 9.14116C25.4331 9.45978 25.6121 9.89191 25.6121 10.3425C25.6121 10.7931 25.4331 11.2252 25.1145 11.5438Z"
        fill="#48464C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.474 2.6133C31.474 2.2267 31.1606 1.9133 30.774 1.9133H2.61415C2.22755 1.9133 1.91415 2.2267 1.91415 2.6133V20.9925L10.422 14.1862C10.5514 14.0826 10.7122 14.0261 10.878 14.0261C11.0438 14.0261 11.205 14.0829 11.3344 14.1865L20.5155 21.5314L23.933 18.1163C24.0698 17.9796 24.2554 17.9027 24.4488 17.9027C24.6423 17.9027 24.8278 17.9796 24.9647 18.1163L31.474 24.6257V2.6133ZM1.91415 30.7731C1.91415 31.1597 2.22755 31.4731 2.61415 31.4731H30.774C31.1606 31.4731 31.474 31.1597 31.474 30.7731V26.6885L24.4488 19.6633L21.0869 23.0252C20.9599 23.1523 20.7906 23.228 20.6113 23.238C20.432 23.2479 20.2553 23.1913 20.1151 23.0792L10.8781 15.6876L1.91415 22.8587V30.7731ZM0.454956 3.12239C0.454956 2.41471 0.736078 1.73603 1.23648 1.23562C1.73688 0.735224 2.41557 0.454102 3.12324 0.454102H30.2649C30.9726 0.454102 31.6513 0.735224 32.1517 1.23562C32.6521 1.73603 32.9332 2.41472 32.9332 3.12239V30.264C32.9332 30.9717 32.6521 31.6504 32.1517 32.1508C31.6513 32.6512 30.9726 32.9323 30.2649 32.9323H3.12324C2.41557 32.9323 1.73688 32.6512 1.23648 32.1508C0.736078 31.6504 0.454956 30.9717 0.454956 30.264V3.12239Z"
        fill="#48464C"
      />
    </svg>
  );
}

export function PencilIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.1123 5.22273C15.2549 5.08012 15.4484 5 15.6501 5C15.8518 5 16.0453 5.08012 16.188 5.22273L19.2308 8.26562C19.3735 8.40828 19.4536 8.60174 19.4536 8.80345C19.4536 9.00517 19.3735 9.19863 19.2308 9.34128L9.34145 19.2307C9.19882 19.3734 9.00536 19.4535 8.80362 19.4536H5.76072C5.55897 19.4536 5.36547 19.3734 5.22281 19.2308C5.08015 19.0881 5 18.8946 5 18.6929V15.65C5.00004 15.4482 5.08022 15.2548 5.22289 15.1121L12.8301 7.5049L15.1123 5.22273ZM13.368 9.11839L6.52145 15.9649V17.9321H8.48868L15.3352 11.0856L13.368 9.11839ZM16.4108 10.01L17.6174 8.80345L15.6501 6.83622L14.4436 8.04273L16.4108 10.01Z"
        fill="#5546A9"
      />
    </svg>
  );
}

export function DownloadInfoIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8958 22.7536C18.8347 22.7536 23.6491 17.9392 23.6491 12.0003C23.6491 6.06147 18.8347 1.24707 12.8958 1.24707C6.95697 1.24707 2.14258 6.06147 2.14258 12.0003C2.14258 17.9392 6.95697 22.7536 12.8958 22.7536Z"
        fill="#25B5BE"
      />
      <path
        d="M12.1078 17.3652L11.5524 10.7147L14.2285 10.7147L13.6731 17.3652L12.1078 17.3652ZM12.8904 9.56399C12.1204 9.56399 11.5524 8.99594 11.5524 8.22591C11.5524 7.45588 12.1204 6.90046 12.8904 6.90046C13.6605 6.90046 14.2285 7.45588 14.2285 8.22591C14.2285 8.99594 13.6605 9.56399 12.8904 9.56399Z"
        fill="white"
      />
    </svg>
  );
}

export function DownloadFileIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.437 3.99902C12.6503 3.99902 12.8549 4.08377 13.0058 4.23462C13.1566 4.38547 13.2414 4.59007 13.2414 4.8034V13.3186L15.0858 11.4741C15.2375 11.3276 15.4407 11.2465 15.6516 11.2484C15.8625 11.2502 16.0643 11.3348 16.2134 11.4839C16.3625 11.6331 16.4471 11.8348 16.449 12.0457C16.4508 12.2566 16.3697 12.4598 16.2232 12.6115L13.0057 15.829C12.8548 15.9798 12.6503 16.0645 12.437 16.0645C12.2237 16.0645 12.0191 15.9798 11.8683 15.829L8.65078 12.6115C8.57395 12.5373 8.51267 12.4486 8.47051 12.3504C8.42836 12.2523 8.40617 12.1467 8.40524 12.0399C8.40431 11.9331 8.42466 11.8272 8.46511 11.7283C8.50555 11.6295 8.56528 11.5397 8.6408 11.4642C8.71633 11.3886 8.80614 11.3289 8.905 11.2885C9.00385 11.248 9.10977 11.2277 9.21658 11.2286C9.32338 11.2295 9.42893 11.2517 9.52707 11.2939C9.62521 11.336 9.71397 11.3973 9.78817 11.4741L11.6326 13.3186V4.8034C11.6326 4.59007 11.7174 4.38547 11.8682 4.23462C12.0191 4.08377 12.2237 3.99902 12.437 3.99902ZM6.80633 16.0647C7.01967 16.0647 7.22426 16.1495 7.37511 16.3003C7.52597 16.4512 7.61071 16.6558 7.61071 16.8691V18.4779H17.2633V16.8691C17.2633 16.6558 17.348 16.4512 17.4989 16.3003C17.6497 16.1495 17.8543 16.0647 18.0676 16.0647C18.281 16.0647 18.4856 16.1495 18.6364 16.3003C18.7873 16.4512 18.872 16.6558 18.872 16.8691V18.4779C18.872 18.9045 18.7025 19.3137 18.4008 19.6154C18.0991 19.9171 17.6899 20.0866 17.2633 20.0866H7.61071C7.18404 20.0866 6.77485 19.9171 6.47315 19.6154C6.17145 19.3137 6.00195 18.9045 6.00195 18.4779V16.8691C6.00195 16.6558 6.0867 16.4512 6.23755 16.3003C6.3884 16.1495 6.593 16.0647 6.80633 16.0647Z"
        fill="#25B5BE"
      />
    </svg>
  );
}

export function EmptyIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.36364 17.364C13.9828 17.364 17.7273 13.6195 17.7273 9.00036C17.7273 4.38125 13.9828 0.636719 9.36364 0.636719C4.74453 0.636719 1 4.38125 1 9.00036C1 13.6195 4.74453 17.364 9.36364 17.364Z"
        fill="#EFEFEF"
      />
      <path
        d="M8.75057 13.1729L8.31857 8.00018L10.4 8.00018L9.96804 13.1729L8.75057 13.1729ZM9.3593 7.10521C8.76039 7.10521 8.31857 6.6634 8.31857 6.06449C8.31857 5.46558 8.76039 5.03358 9.3593 5.03358C9.95821 5.03358 10.4 5.46558 10.4 6.06449C10.4 6.6634 9.95821 7.10522 9.3593 7.10521Z"
        fill="#AEA9B1"
      />
    </svg>
  );
}

export function CancelIcon() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 12.5713C20 16.9896 16.4183 20.5713 12 20.5713C7.58172 20.5713 4 16.9896 4 12.5713C4 8.15301 7.58172 4.57129 12 4.57129C16.4183 4.57129 20 8.15301 20 12.5713ZM14.687 15.2582C14.4527 15.4926 14.0728 15.4926 13.8385 15.2582L12 13.4198L10.1615 15.2583C9.92721 15.4926 9.54731 15.4926 9.31299 15.2583C9.07868 15.0239 9.07868 14.644 9.31299 14.4097L11.1515 12.5712L9.313 10.7328C9.07869 10.4984 9.07869 10.1186 9.313 9.88424C9.54732 9.64992 9.92722 9.64992 10.1615 9.88424L12 11.7227L13.8385 9.88424C14.0728 9.64993 14.4527 9.64993 14.687 9.88424C14.9213 10.1186 14.9213 10.4985 14.687 10.7328L12.8485 12.5712L14.687 14.4097C14.9213 14.644 14.9213 15.0239 14.687 15.2582Z"
        fill="#DB2828"
      />
    </svg>
  );
}

export function DrawerIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 6.10528C3 5.49485 3.52558 5 4.17391 5H19.8261C20.4744 5 21 5.49485 21 6.10528C21 6.71571 20.4744 7.21056 19.8261 7.21056H4.17391C3.52558 7.21056 3 6.71571 3 6.10528ZM3 12.0007C3 11.3903 3.52558 10.8954 4.17391 10.8954H19.8261C20.4744 10.8954 21 11.3903 21 12.0007C21 12.6111 20.4744 13.106 19.8261 13.106H4.17391C3.52558 13.106 3 12.6111 3 12.0007ZM4.17391 16.7891C3.52558 16.7891 3 17.284 3 17.8944C3 18.5049 3.52558 18.9997 4.17391 18.9997H19.8261C20.4744 18.9997 21 18.5049 21 17.8944C21 17.284 20.4744 16.7891 19.8261 16.7891H4.17391Z"
        fill="#333333"
      />
    </svg>
  );
}

export function SearchIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66864 2.66696C5.60713 2.66696 4.58908 3.08867 3.83848 3.83932C3.08787 4.58997 2.66618 5.60807 2.66618 6.66965C2.66618 7.73123 3.08787 8.74933 3.83848 9.49998C4.58908 10.2506 5.60713 10.6723 6.66864 10.6723C7.73016 10.6723 8.7482 10.2506 9.49881 9.49998C10.2494 8.74933 10.6711 7.73123 10.6711 6.66965C10.6711 5.60807 10.2494 4.58997 9.49881 3.83932C8.7482 3.08867 7.73016 2.66696 6.66864 2.66696ZM1.33203 6.66965C1.33215 5.82032 1.53497 4.98328 1.92362 4.22811C2.31227 3.47293 2.87554 2.82142 3.56661 2.32772C4.25767 1.83403 5.05658 1.51241 5.89694 1.38959C6.73729 1.26677 7.59483 1.34631 8.39827 1.62158C9.2017 1.89685 9.92785 2.35991 10.5163 2.97228C11.1048 3.58465 11.5387 4.32863 11.7819 5.14241C12.025 5.95618 12.0704 6.81625 11.9144 7.65111C11.7583 8.48598 11.4053 9.27154 10.8846 9.94252L14.4781 13.5363C14.5996 13.6621 14.6669 13.8306 14.6653 14.0055C14.6638 14.1804 14.5937 14.3477 14.47 14.4714C14.3463 14.5951 14.179 14.6653 14.0041 14.6668C13.8292 14.6683 13.6607 14.6011 13.5349 14.4796L9.94132 10.8858C9.15247 11.4983 8.2076 11.8771 7.21416 11.9792C6.22071 12.0813 5.21855 11.9026 4.32163 11.4633C3.42472 11.0241 2.66905 10.342 2.14054 9.49454C1.61204 8.64712 1.33192 7.66839 1.33203 6.66965Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function EmptyImg() {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.1141 22.5429C35.7955 22.8615 35.3634 23.0405 34.9128 23.0405C34.4622 23.0405 34.0301 22.8615 33.7115 22.5429C33.3929 22.2242 33.2139 21.7921 33.2139 21.3415C33.2139 20.8909 33.3929 20.4588 33.7115 20.1402C34.0301 19.8216 34.4622 19.6426 34.9128 19.6426C35.3634 19.6426 35.7955 19.8216 36.1141 20.1402C36.4328 20.4588 36.6118 20.8909 36.6118 21.3415C36.6118 21.7921 36.4328 22.2242 36.1141 22.5429Z"
        fill="#48464C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.4731 13.6138C42.4731 13.2272 42.1597 12.9138 41.7731 12.9138H13.6133C13.2267 12.9138 12.9133 13.2272 12.9133 13.6138V31.993L21.4211 25.1867C21.5506 25.0831 21.7114 25.0266 21.8771 25.0266C22.0429 25.0266 22.2041 25.0834 22.3335 25.187L31.5146 32.5319L34.9321 29.1168C35.069 28.98 35.2545 28.9032 35.448 28.9032C35.6414 28.9032 35.827 28.98 35.9638 29.1168L42.4731 35.6262V13.6138ZM12.9133 41.7736C12.9133 42.1602 13.2267 42.4736 13.6133 42.4736H41.7731C42.1597 42.4736 42.4731 42.1602 42.4731 41.7736V37.6889L35.448 30.6638L32.086 34.0257C31.9591 34.1528 31.7897 34.2285 31.6104 34.2385C31.4312 34.2484 31.2544 34.1918 31.1142 34.0797L21.8773 26.6881L12.9133 33.8592V41.7736ZM11.4541 14.1229C11.4541 13.4152 11.7352 12.7365 12.2356 12.2361C12.736 11.7357 13.4147 11.4546 14.1224 11.4546H41.264C41.9717 11.4546 42.6504 11.7357 43.1508 12.2361C43.6512 12.7365 43.9323 13.4152 43.9323 14.1229V41.2645C43.9323 41.9722 43.6512 42.6509 43.1508 43.1513C42.6504 43.6517 41.9717 43.9328 41.264 43.9328H14.1224C13.4147 43.9328 12.736 43.6517 12.2356 43.1513C11.7352 42.6509 11.4541 41.9722 11.4541 41.2645V14.1229Z"
        fill="#48464C"
      />
    </svg>
  );
}

export function SeletedAddressIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3471 0C6.83461 0 3.14258 3.93816 3.14258 8.75148C3.14258 14.6587 10.3215 21.3317 10.6292 21.6599C10.8343 21.7693 11.142 21.8787 11.3471 21.8787C11.5522 21.8787 11.8599 21.7693 12.065 21.6599C12.3727 21.3317 19.5516 14.6587 19.5516 8.75148C19.5516 3.93816 15.8596 0 11.3471 0Z"
        fill="#5546A9"
      />
      <circle cx="11.3147" cy="8.90458" r="3.14286" fill="white" />
    </svg>
  );
}

export function DefaultImgIcon() {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.3755 17.7124C28.1252 17.9627 27.7856 18.1034 27.4316 18.1034C27.0776 18.1034 26.738 17.9627 26.4877 17.7124C26.2373 17.462 26.0967 17.1225 26.0967 16.7685C26.0967 16.4144 26.2373 16.0749 26.4877 15.8246C26.738 15.5742 27.0776 15.4336 27.4316 15.4336C27.7856 15.4336 28.1252 15.5742 28.3755 15.8246C28.6258 16.0749 28.7665 16.4144 28.7665 16.7685C28.7665 17.1225 28.6258 17.462 28.3755 17.7124Z"
        fill="#48464C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.3721 11.1465C33.3721 10.5942 32.9244 10.1465 32.3721 10.1465H11.1465C10.5943 10.1465 10.1465 10.5942 10.1465 11.1465V25.1373L16.8313 19.7895C16.933 19.7081 17.0593 19.6637 17.1896 19.6637C17.3198 19.6637 17.4465 19.7083 17.5481 19.7897L24.7619 25.5607L27.4471 22.8775C27.5546 22.77 27.7003 22.7096 27.8524 22.7096C28.0044 22.7096 28.1501 22.77 28.2576 22.8775L33.3721 27.9919V11.1465ZM10.1465 32.3721C10.1465 32.9244 10.5943 33.3721 11.1465 33.3721H32.3721C32.9244 33.3721 33.3721 32.9244 33.3721 32.3721V29.6127L27.8524 24.0929L25.2108 26.7345C25.1111 26.8343 24.978 26.8938 24.8371 26.9016C24.6963 26.9094 24.5574 26.865 24.4472 26.7769L17.1896 20.9692L10.1465 26.6036V32.3721ZM9.00003 11.0965C9.00003 10.5405 9.22091 10.0072 9.61408 9.61405C10.0073 9.22088 10.5405 9 11.0965 9H32.4221C32.9782 9 33.5114 9.22088 33.9046 9.61405C34.2978 10.0072 34.5186 10.5405 34.5186 11.0965V32.4221C34.5186 32.9781 34.2978 33.5114 33.9046 33.9045C33.5114 34.2977 32.9782 34.5186 32.4221 34.5186H11.0965C10.5405 34.5186 10.0073 34.2977 9.61408 33.9045C9.22091 33.5114 9.00003 32.9781 9.00003 32.4221V11.0965Z"
        fill="#48464C"
      />
    </svg>
  );
}

export function NotRequiredIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="4.5" y="6.5" width="8" height="6" rx="0.5" stroke="#48464C" />
      <rect x="1" y="2" width="9" height="11" rx="1" fill="#48464C" />
      <rect x="3" y="4" width="5" height="1.6" rx="0.4" fill="white" />
      <rect x="3" y="7" width="4" height="1.6" rx="0.4" fill="white" />
    </svg>
  );
}
